module.exports = __webpack_public_path__ + "img/otprostogo.22d5d5d9.png";